import { render, staticRenderFns } from "./FlightsPage.vue?vue&type=template&id=93f5d72c&"
import script from "./FlightsPage.vue?vue&type=script&lang=js&"
export * from "./FlightsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports